package com.shadowings.gero.presentation.util

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.unit.dp

@Composable
fun ColumnOrRow(
    isLandscape: Boolean,
    isTablet: Boolean,
    content: @Composable () -> Unit
) {
    if (isLandscape && !isTablet) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(4.dp),
            verticalAlignment = Alignment.CenterVertically
        ) {
            content()
        }
    } else {
        Column(
            verticalArrangement = Arrangement.spacedBy(4.dp),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            content()
        }
    }
}

@Composable
fun BoxOrRow(
    isLandscape: Boolean,
    content: @Composable () -> Unit
) {
    if (!isLandscape) {
        Box {
            content()
        }
    } else {
        Row {
            content()
        }
    }
}